module.exports = "images/maximum-engineering_poster@3x.jpg";